import type { ComponentType } from 'react';
import type { TFlowNode } from '@hookpipe/contracts/flows/schemas/flow-graph.schema';

import {
  ActionIcon,
  AggregateIcon,
  AgentIcon,
  AiIcon,
  CodeIcon,
  CopyIcon,
  DestinationsIcon,
  FilterIcon,
  HttpIcon,
  LookupIcon,
  LoopIcon,
  MailIcon,
  MergeIcon,
  MessageIcon,
  PlayIcon,
  RouteIcon,
  SendIcon,
  SetFieldsIcon,
  SourcesIcon,
  SplitIcon,
  WaitIcon,
  type TIconProps,
  type TIconSize,
} from '../../../shared/ui/icons';

type TGlyph = ComponentType<TIconProps>;

// The API sends no icon for a built-in type, so the glyph is the one design/flow-editor draws.
const BY_TYPE: Record<string, TGlyph> = {
  'trigger.webhook': SourcesIcon,
  'trigger.schedule': WaitIcon,
  'trigger.manual': PlayIcon,
  filter: FilterIcon,
  dedupe: CopyIcon,
  route: RouteIcon,
  split: SplitIcon,
  aggregate: AggregateIcon,
  merge: MergeIcon,
  loop: LoopIcon,
  wait: WaitIcon,
  code: CodeIcon,
  set: SetFieldsIcon,
  lookup: LookupIcon,
  deliver: DestinationsIcon,
  'ai.generate': AiIcon,
  'ai.extract': AiIcon,
  'ai.classify': AiIcon,
  'ai.agent': AgentIcon,
};

// An `action` is drawn by its app: the connector key is also the palette's `icon`.
const BY_CONNECTOR: Record<string, TGlyph> = {
  slack: MessageIcon,
  telegram: SendIcon,
  email: MailIcon,
  http: HttpIcon,
  ai: AiIcon,
};

export const NodeGlyph = ({ node, size = 'md' }: { node: TFlowNode; size?: TIconSize }) => {
  const connector = typeof node.config?.connector === 'string' ? node.config.connector : '';
  const Glyph =
    node.type === 'action'
      ? (BY_CONNECTOR[connector] ?? ActionIcon)
      : (BY_TYPE[node.type] ?? ActionIcon);
  return <Glyph size={size} />;
};
